module.exports = __webpack_public_path__ + "img/fr_empty_folder.61d10133.png";